var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 22C2 22 1.35417 21.7458 0.8125 21.2375C0.270833 20.7292 0 20.1 0 19.35V5.39999C0 4.76665 0.195833 4.19999 0.5875 3.69999C0.979167 3.19999 1.49167 2.88332 2.125 2.74999L12 0.799988V16.8L2.525 18.7C2.375 18.7333 2.25 18.8125 2.15 18.9375C2.05 19.0625 2 19.2 2 19.35C2 19.5333 2.075 19.6875 2.225 19.8125C2.375 19.9375 2.55 20 2.75 20H14V3.99999H16V22H2.75ZM5 16.175L10 15.2V3.24999L5 4.22499V16.175ZM3 16.575V4.62499L2.625 4.69999C2.44167 4.73332 2.29167 4.81249 2.175 4.93749C2.05833 5.06249 2 5.21665 2 5.39999V16.825C2.08333 16.7917 2.17083 16.7625 2.2625 16.7375C2.35417 16.7125 2.44167 16.6917 2.525 16.675L3 16.575Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBook);
export default __webpack_public_path__ + "static/media/info_book.ce9e8e16a109e46b69291c62665fba71.svg";
export { ForwardRef as ReactComponent };